export enum SexWith {
  'Males' = 'Males',
  'Females' = 'Females',
  'Both' = 'Both',
}
